import { GROUPED_REQUEST_STATUS } from 'src/api/constants/request'
import { TrackingWorkOrderProvider } from 'src/api/domains/service-tracking/serviceTracking.types'
import { GroupedRequestStatus } from 'src/api/types/requests'

export const displayServiceProviderContact = (
  status: GroupedRequestStatus,
  provider?: TrackingWorkOrderProvider | null,
): boolean => {
  if (
    status !== GROUPED_REQUEST_STATUS.VOIDED &&
    status !== GROUPED_REQUEST_STATUS.COMPLETED &&
    !!provider
  ) {
    return true
  }

  return false
}
